import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Card, CardContent, Divider, CircularProgress } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { useDispatch } from 'react-redux'
import useRouter from 'utils/useRouter'
import { useCargoService } from 'hooks/useCargoService'
import { criarAlerta, logoutTokenExpirado } from 'actions'
import { uniqueId } from 'lodash'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {},
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  inner: {
    minWidth: 400,
  },
  botoes: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(4),
  },
  actions: {
    justifyContent: 'flex-end',
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1),
  },
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export const DetailPanel = (props) => {
  const { className, id, ...rest } = props
  const classes = useStyles()
  const cargoService = useCargoService()
  const [dados, setDados] = useState([])
  const [carregando, setCarregando] = useState(false)
  const [value, setValue] = useState(0)
  const dispatch = useDispatch()
  const router = useRouter()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  useEffect(() => {
    const fetchDados = async () => {
      setCarregando(true)
      try {
        const cargo = await cargoService.listarCargoAsync(id, setCarregando)
        if (cargo) {
          setDados(cargo)
        }
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logoutTokenExpirado(router))
        } else {
          dispatch(criarAlerta(error.response, router, '/cargos'))
        }
        setCarregando(false)
      }
    }

    fetchDados()
    
  }, [dispatch, id, router])

  return carregando ? (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  ) : (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Divider />
      <AppBar color="transparent" position="static">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Detalhes" {...a11yProps(0)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Nome do cargo - Sigla:</Typography>
                  </TableCell>
                  <TableCell align="left"> {`${dados.nome} - ${dados.sigla}`}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Descrição:</Typography>
                  </TableCell>
                  <TableCell align="left"> {dados.descricao}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="h6">Permissões:</Typography>
                  </TableCell>
                  <TableCell align="left">
                    {dados.perms
                      ? dados.perms.map((item) => (
                          <li key={uniqueId()}>{`${item.nome} - ${item.descricao}`}</li>
                        ))
                      : null}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </PerfectScrollbar>
        </CardContent>
      </TabPanel>
    </Card>
  )
}
